import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from '@arreeba/ristoranti-frontend-lib/lib/helpers/i18n';

const STRATEGY_SINGLE = 'SINGLE';
const STRATEGY_MULTI_RANGE = 'MULTI_RANGE';

const formatError = (status) => {
  if (status.minSelection === 1) {
    return `Seleziona almeno ${status.minSelection} elemento`;
  }
  return `Seleziona almeno ${status.minSelection} elementi`;
};

const formatInfo = (strategy, status) => {
  if (status.isCompleted) return '';
  if (strategy === STRATEGY_SINGLE) {
    return `Seleziona ${status.minSelection} elementi`;
  }
  return `Puoi selezionare ancora ${status.remaining} elementi`;
};

const Modifier = (props) => {
  const data = props.data;
  return (
    <div className="itemModifier">
      <p className="itemModifier__name primary">{data.name}</p>
      <p className="itemModifier__info">
        {formatInfo(data.price_strategy, props.status)}
      </p>
      {!props.status.isValid && props.showErrors &&
        <p className="itemModifier__error">{formatError(props.status)}</p>
      }
      <form name={`modifier_${data.id}`} className="itemModifier__content">
        {
          data.items.map(item => (
            <p
              className="itemModifier__item"
              htmlFor={`modifier_${item.id}`}
              key={item.id}
              onClick={() => {
                if (props.status.isCompleted && !item.selected) return;
                props.onUpdate(data, item);
              }}
            >
              <span
                className={
                  classNames(
                    'itemModifier__icon',
                    { 'primary--background': item.selected },
                  )
                }
              >
                <i className="bi_interface-tick" />
              </span>
              <span className="itemModifier__nameWrapper">
                <span className="itemModifier__name">{item.name}</span>
                <span className="itemModifier__description">{item.description}</span>
              </span>
              <span className="itemModifier__extraprice">
                { item.price > 0 ? ` + ${i18n.formatPrice(item.price)}` : ''}
              </span>
            </p>
          ))
        }
      </form>
    </div>
  );
};


const ModifierShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  price_strategy: PropTypes.oneOf([STRATEGY_SINGLE, STRATEGY_MULTI_RANGE]),
  min_selection_points: PropTypes.number,
  max_selection_points: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.shape({
    available: PropTypes.bool,
    description: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    price: PropTypes.number,
  })),
});

Modifier.propTypes = {
  data: ModifierShape,
  showErrors: PropTypes.bool,
  onUpdate: PropTypes.func,
  status: PropTypes.shape({
    selected: PropTypes.number,
    remaining: PropTypes.number,
    minSelection: PropTypes.number,
    maxSelection: PropTypes.number,
    isCompleted: PropTypes.bool,
    isValid: PropTypes.bool,
  }),
};

export default Modifier;



// WEBPACK FOOTER //
// ./src/components/menu/modifier.js